module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nba/points/basketball_points-797c4ae643ce5cb1d2c81a8e273d749d.svg";